<template lang="jade">
  div
    div
      .row.mb40
        .col-lg-3.col-lg-offset-3.col-md-2.col-md-offset-3.center-element
          h4 Folhas disponíveis
          check-list(:model="'datesVerify'",
                      :call-server="'loadDatesVerify'",
                      :field="'date'",
                      :loading="'isDatesVerifyLoading'",
                      :selectMultiple="false",
                      :parseField="parseDate")
        .col-lg-4.col-md-4.center-element(v-if="selectedDate")
          label.filter-select Funcionários
            input(type="radio" name="filter" v-model="filter" value="employee" id="employee", @change="changedFilter")
          label.filter-select Locais de trabalho
            input(type="radio" name="filter" v-model="filter" value="company" id="company", @change="changedFilter")
          label.filter-select Grupos
            input(type="radio" name="filter" v-model="filter" value="groups" id="groups", @change="changedFilter")

          check-list(:model="'employeesSheetVerify'",
                     :customSeach="customSeachEmployees",
                      v-if="filter == 'employee'",
                      :idSelection="'uuid'",
                      :call-server="'loadEmployeesSheetVerify'",
                      :field="'employee.name'",
                      :loading="'isEmployeesSheetVerifyLoading'",
                      :doRefetchOnUpdate="'datesVerifySelected'",
                      :additionalInfo="{right: 'end_date'}")
          check-list(:model="'companiesSheetVerify'",
            v-if="filter == 'company'",
            :idSelection="'id'",
            :call-server="'loadCompaniesSheetVerify'",
            :field="'company.name'",
            :loading="'isEmployeesSheetVerifyLoading'",
            :doRefetchOnUpdate="'datesVerifySelected'",
            :additionalInfo="{right: 'numSheets'}")

          check-list(:model="'groupsSheetVerify'",
            v-if="filter == 'groups'",
            :idSelection="'id'",
            :call-server="'loadGroupsSheetVerify'",
            :field="'userGroup.name'",
            :loading="'isEmployeesSheetVerifyLoading'",
            :doRefetchOnUpdate="'datesVerifySelected'",
            :additionalInfo="{right: 'numSheets'}")

    div
      .row
        .col-md-3.col-md-offset-3.col-sm-12
          button.btn.btn3d.btn-warning.btn-lg.pull-right(v-on:click="reprocessSheets()",
          :disabled="!selectedDate || employeesVerifySelected.length == 0 &&  groupsVerifySelected.length == 0") Reprocessar Folhas selecionadas
        .col-md-3.col-sm-12
          button.btn.btn3d.btn-success.btn-lg.pull-left(v-on:click="verifySheets()",
            :disabled="!selectedDate || (employeesVerifySelected.length == 0 && companiesVerifySelected.length == 0 &&  groupsVerifySelected.length == 0)") Corrigir Folhas selecionadas

</template>
<script>
import MultiSelect from '../common/MultiSelect/MultiSelect.vue'

import CheckList from './common/CheckList.vue'
import { handleRequest } from '../services'
import swal from 'sweetalert2'

export default {
  components: {
    CheckList,
    MultiSelect
  },
  data () {
    return {
      filter: 'employee'
    }
  },
  computed: {
    selectedDate () {
      return this.$store.getters.datesVerifySelected.items[0]
    },
    employeesVerifySelected () {
      let sheets = []
      this.$store.getters.employeesSheetVerify.forEach(sheet => {
        if (this.$store.getters.employeesSheetVerifySelected.items.includes(sheet.uuid)) {
          sheets.push(sheet)
        }
      })
      return sheets
    },
    companiesVerifySelected () {
      let sheets = []
      this.$store.getters.companiesSheetVerify.forEach(place => {
        if (this.$store.state.CheckList.companiesSheetVerifySelected.items.includes(place.id)) {
          sheets = [...place.sheets, ...sheets]
        }
      })
      return sheets
    },
    groupsVerifySelected () {
      let sheets = []
      this.$store.getters.groupsSheetVerify.forEach(group => {
        if (this.$store.state.CheckList.groupsSheetVerifySelected.items.includes(group.id)) {
          sheets = [...group.sheetsUuids.map(i => ({uuid: i})), ...sheets]
        }
      })
      return sheets
    }
  },
  created () {
    this.$store.commit('resetQueue')
  },
  methods: {
    changedFilter () {
      this.$store.commit('resetSelectedEmployeesAndCompanies')
      if (this.filter === 'employee') {
        this.$store.dispatch('loadEmployeesSheetVerify')
      } else if (this.filter === 'company') {
        this.$store.dispatch('loadCompaniesSheetVerify')
      } else {
        this.$store.dispatch('loadGroupsSheetVerify')
      }
    },
    loadCompanies (options) {
      return this.$API.company.get({...options, active: true})
    },
    verifySheets () {
      if (this.filter === 'employee') {
        this.$store.dispatch('verifyQueue', this.employeesVerifySelected)
      } else if (this.filter === 'company') {
        this.$store.dispatch('verifyQueue', this.companiesVerifySelected)
      } else {
        this.$store.dispatch('verifyQueue', this.groupsVerifySelected)
      }
    },
    parseGroup (item) {
      console.log(item)
      return 'lol'
    },
    reprocessSheets () {
      const params = {
        kind: 'all',
        sheet_uuids: this.employeesVerifySelected.map(sheet => sheet.uuid)
      }

      handleRequest.apiPost('reprocess-sheet-digits', params)
        .then(response => {
          swal({
            title: response.data.success,
            type: 'success'
          })
          this.$store.dispatch('loadEmployeesSheetVerify')
        })
        .catch(error => {
          swal({
            title: 'Aconteceu um erro',
            text: error.data || 'Por favor, tente novamente',
            type: 'error'
          })
          this.$store.dispatch('loadEmployeesSheetVerify')
        })
    },
    parseDate (date) {
      const month = date[date.length - 2] + date[date.length - 1]
      const year = date[0] + date[1] + date[2] + date[3]
      return month + '/' + year
    },
    customSeachEmployees (item, search) {
      return item.employee.name.toLocaleLowerCase().includes(search.toLocaleLowerCase()) || item.employee.code.includes(search) || item.employee.company.code.includes(search)
    }
  }
}
</script>

<style scoped>
@media (min-width: 1200px) {
  .col-lg-offset-3 {
    margin-left: 19%;
  }
}
.filter-select {
  font-weight: 100;
  font-size: 18px;
  padding-left: 10px;
  padding-right: 10px;
}
.filter-select input {
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// SheetChecker.vue?20762bfe